import './index.less'

import PropTypes from 'ant-design-vue/es/_util/vue-types'
import 'ant-design-vue/es/layout/style'
import Layout from 'ant-design-vue/es/layout'
import 'ant-design-vue/es/input/style'
import Input from 'ant-design-vue/es/input'
import 'ant-design-vue/es/icon/style'
import Icon from 'ant-design-vue/es/icon'
import { isFun } from '../../utils/util'
import BaseMenu from '../RouteMenu'

const { Sider } = Layout

export const SiderMenuProps = {
  i18nRender: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]).def(false),
  mode: PropTypes.string.def('inline'),
  theme: PropTypes.string.def('dark'),
  contentWidth: PropTypes.oneOf(['Fluid', 'Fixed']).def('Fluid'),
  collapsible: PropTypes.bool,
  collapsed: PropTypes.bool,
  handleCollapse: PropTypes.func,
  menus: PropTypes.array,
  siderWidth: PropTypes.number.def(256),
  isMobile: PropTypes.bool,
  layout: PropTypes.string.def('inline'),
  fixSiderbar: PropTypes.bool,
  logo: PropTypes.any,
  title: PropTypes.string.def(''),
  // render function or vnode
  menuHeaderRender: PropTypes.oneOfType([PropTypes.func, PropTypes.array, PropTypes.object, PropTypes.bool]),
  menuRender: PropTypes.oneOfType([PropTypes.func, PropTypes.array, PropTypes.object, PropTypes.bool])
}

export const defaultRenderLogo = (h, logo) => {
  if (typeof logo === 'string') {
    return <img src={logo} alt="logo" />
  }
  if (typeof logo === 'function') {
    return logo()
  }
  return h(logo)
}

export const defaultRenderLogoAntTitle = (h, props) => {
  const {
    logo = 'https://gw.alipayobjects.com/zos/antfincdn/PmY%24TNNDBI/logo.svg',
    title,
    menuHeaderRender
  } = props

  if (menuHeaderRender === false) {
    return null
  }
  const logoDom = defaultRenderLogo(h, logo)
  const titleDom = <h1>{title}</h1>

  if (menuHeaderRender) {
    return isFun(menuHeaderRender) &&
      menuHeaderRender(h, logoDom, props.collapsed ? null : titleDom, props) ||
      menuHeaderRender
  }
  return (
    <span>
      {logoDom}
      {titleDom}
    </span>
  )
}

const menuTitle = (item, i18nRender) => {
  const title = item && item.meta && item.meta.title
  if (!title) return ''
  return String((i18nRender && i18nRender(title)) || title)
}

const filterMenus = (menus, keyword, i18nRender) => {
  const query = String(keyword || '').trim().toLowerCase()
  if (!query) return menus || []
  return (menus || []).reduce((list, item) => {
    if (!item || item.hidden) return list
    const children = (item.children || []).filter(child => child && !child.hidden)
    const matchedChildren = filterMenus(children, query, i18nRender)
    const selfMatch = menuTitle(item, i18nRender).toLowerCase().indexOf(query) >= 0
    if (selfMatch) {
      list.push(item)
    } else if (matchedChildren.length) {
      list.push(Object.assign({}, item, { children: matchedChildren }))
    }
    return list
  }, [])
}

const SiderMenu = {
  name: 'SiderMenu',
  model: {
    prop: 'collapsed',
    event: 'collapse'
  },
  props: SiderMenuProps,
  data () {
    return {
      keyword: ''
    }
  },
  render (h) {
    const {
      collapsible,
      collapsed,
      siderWidth,
      fixSiderbar,
      mode,
      theme,
      menus,
      logo,
      title,
      onMenuHeaderClick = () => null,
      i18nRender,
      menuHeaderRender,
      menuRender
    } = this
    const siderCls = ['ant-pro-sider-menu-sider']
    if (fixSiderbar) siderCls.push('fix-sider-bar')
    if (theme === 'light') siderCls.push('light')
    if (!collapsed) siderCls.push('has-menu-search')
    const filteredMenus = collapsed ? menus : filterMenus(menus, this.keyword, i18nRender)
    const searching = !collapsed && !!String(this.keyword || '').trim()
    //
    // const handleCollapse = (collapsed, type) => {
    //   this.$emit('collapse', collapsed)
    // }

    const headerDom = defaultRenderLogoAntTitle(h, {
      logo, title, menuHeaderRender, collapsed
    })

    return (<Sider
      class={siderCls}
      breakpoint={'lg'}
      trigger={null}
      width={siderWidth}
      theme={theme}
      collapsible={collapsible}
      collapsed={collapsed}
    >
      {headerDom && (
        <div
          class="ant-pro-sider-menu-logo"
          onClick={onMenuHeaderClick}
          id="logo"
        >
          <router-link to={{ path: '/' }}>
            {headerDom}
          </router-link>
        </div>
      )}
      {!collapsed && (
        <div class="ant-pro-sider-menu-search">
          <Input
            value={this.keyword}
            allowClear
            placeholder="搜索菜单"
            onChange={(e) => { this.keyword = e && e.target ? e.target.value : '' }}
          >
            <Icon slot="prefix" type="search" />
          </Input>
        </div>
      )}
      {searching && !filteredMenus.length ? (
        <div class="ant-pro-sider-menu-empty">没有匹配的菜单</div>
      ) : (menuRender && (
        isFun(menuRender) &&
          menuRender(h, Object.assign({}, this.$props, { menus: filteredMenus })) ||
          menuRender
      ) || (
        <BaseMenu collapsed={collapsed} menus={filteredMenus} mode={mode} theme={theme} i18nRender={i18nRender} expandAll={searching} />
      ))}
    </Sider>)
  }
}

export default SiderMenu
